import styled from 'styled-components';
import { Title } from './title';
import { Button } from './button';
import { ButtonText } from './buttonText';
import { ButtonContainer } from './buttonContainer';

const HomeBanner = styled.div`
  overflow: hidden;
`;

HomeBanner.Title = Title;
HomeBanner.Button = Button;
HomeBanner.ButtonText = ButtonText;
HomeBanner.ButtonContainer = ButtonContainer;

export default HomeBanner;
